import { ofType } from "redux-observable";
import { from } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { actionAddPelletsInScreenCenterAnimation } from "../../animation/actionPelletAnimations";
import { getResourceIconInfo } from "../../generic/icon/getResourceIconInfo";
import { TypeActionGrantRewards } from "../../grant-rewards/actionGrantRewards";
import { TypeGrantRewards } from "../../grant-rewards/TypeGrantRewards";
import { actionInventoryInfoAddResource } from "../../info/inventory/actionInventoryInfo";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
export var epicDoghouseRewardReceived = function (action$, state$) {
    return action$.pipe(ofType(TypeActionGrantRewards.Collect), filter(function () { return state$.value.grantRewards.rewardsType === TypeGrantRewards.Doghouse; }), filter(function () {
        return state$.value.grantRewards.rewards != undefined &&
            state$.value.grantRewards.rewards.resourceRewards.length !== 0;
    }), switchMap(function () {
        var _a = state$.value.grantRewards.rewards, resourceRewards = _a.resourceRewards, packageId = _a.packageId;
        var rewardPelletsInfo = resourceRewards.map(function (res) { return getResourceIconInfo(res); });
        return from([
            actionInventoryInfoAddResource(resourceRewards),
            actionAddPelletsInScreenCenterAnimation(packageId, rewardPelletsInfo),
            actionModalClose(IdModal.DogTreatReward),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/epics/epicDoghouseRewardReceived.ts
// module id = 1840
// module chunks = 3